'use client';
import { useState } from 'react';
import { IcoClose } from './common/Icons.jsx';
import styles from './NumpadModal.module.css';

const KEYS = ['1','2','3','4','5','6','7','8','9','⌫','0','↵'];

export default function NumpadModal({ onSearch, onClose }) {
  const [value, setValue] = useState('');

  const press = (k) => {
    if (k === '⌫') {
      setValue((v) => v.slice(0, -1));
    } else if (k === '↵') {
      if (value.trim()) onSearch(value.trim());
      onClose();
    } else {
      setValue((v) => (v + k).slice(0, 20));
    }
  };

  return (
    <div className={styles.overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className={styles.panel}>
        <div className={styles.header}>
          <span className={styles.title}>Código de barras</span>
          <button className={styles.closeBtn} onClick={onClose}><IcoClose size={13} /></button>
        </div>

        <div className={styles.display}>
          <span className={styles.displayValue}>{value || <span className={styles.placeholder}>Ingresa el código</span>}</span>
        </div>

        <div className={styles.grid}>
          {KEYS.map((k) => (
            <button
              key={k}
              className={`${styles.key} ${k === '↵' ? styles.keyEnter : k === '⌫' ? styles.keyDel : ''}`}
              onClick={() => press(k)}
            >
              {k}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
